import {
  AppBar,
  Box,
  CardMedia,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Dialog,
  Button,
  Stack,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogProps,
  Divider,
  InputAdornment,
  Select,
  Grid,
  Tooltip,
  InputBaseProps,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  ApplicationsIcon,
  FundsSetup,
  RiskProfile,
  AMCAdmins,
  Reports,
  DashboardIcon,
} from './customSVGs';
import { useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux-store/actions/auth';
import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToApp from '@mui/icons-material/ExitToApp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import { RootStateType } from '../redux-store/reducers';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  APPLICATION_TYPE,
  ENABLE_BLUK_UPLOAD_USERS_AND_FUND,
  ENABLE_DIGILOCKER_FLOW,
  ENABLE_DOWNLOAD_USERS_DATA,
  ENABLE_Email_Consent,
  ENABLE_PHYSICAL_APPLICATION,
  REJECTED_ROLES,
  RTAApproverSendBackRoles,
  USER_ROLES,
} from '../utils/constant';
import { Formik, useFormikContext } from 'formik';
import {
  ApplicationStatusOrClassBasedOnRole,
  MakerOrAdmin,
  RTAApproverLoggedIn,
  getCountryCodes,
  handleDownload,
  isJson,
  preventSpecialCharacters,
} from '../utils/utilityFunctions';
import { Applicant, ApplicationProps, SendBackType } from '../redux-store/types/api-types';
import { Item, ItemDetails, RejectedDetails } from './ApplicationDetails';
import { Notes, SubHeading } from './investors/components';
import { KeyValue } from './ApplicationDetails/contributor';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { getParams } from '../redux-store/actions/application';
import { initialState } from '../redux-store/reducers/queryParams';
import { renderFilteredOptions, SearchFieldWrapper } from '../lib/formik/searchSelectField';
import { LoadingButton } from '@mui/lab';
import { exportUsersData } from '../redux-store/actions/userManagement';
import { reportDownload } from './Reports/report-utils';
import JSONPretty from 'react-json-pretty';
import { styles } from '../Styles/styles';
import MFSelectField from '../lib/formik/SelectField';
import { formatShortDateAndTime } from '../utils/date';
import { Logo2, LogoSideBar } from './Logo';

export function OtpTimer({ onResend }: { onResend: () => void }): JSX.Element {
  const [counter, setCounter] = useState(60);

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <Box>
      <Typography>
        <Button
          sx={{
            color: 'primary.main',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            p: 0,
            ':hover': {
              background: 'none',
            },
          }}
          disabled={counter > 0}
          onClick={() => {
            try {
              onResend();
              setCounter(60);
            } catch (e) {
              console.error((e as Error).message);
            }
          }}>
          Resend OTP
        </Button>
        <br />
        {counter > 0 && `in ${counter} seconds`}
      </Typography>
    </Box>
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}>
      <Typography sx={{ color: 'common.white' }}>Powered By </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{ width: 'unset' }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
  cvl,
}: {
  LoginText: string;
  children: JSX.Element;
  cvl?: boolean;
}): JSX.Element => {
  return (
    <Stack
      sx={{
        minHeight: '100vh',
        background: '#f2f6f8 url("/images/login-bg.svg")',
        backgroundSize: 'cover',
      }}>
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CardMedia
            component="img"
            src="/images/ikigai-logo.svg"
            alt="Logo"
            sx={{ width: '170px', m: 3, mt: 1 }}
          />
        </Box>
      </AppBar>
      <Box
        component="main"
        sx={{
          // height: 'calc(100vh - 43px)',
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          // mt: '-88px',
        }}>
        <Box
          sx={{
            bgcolor: 'grey.50',
            height: { xs: 'unset', sm: 'unset' },
            minHeight: { xs: 'unset', sm: '470px' },
            width: cvl ? 'clamp(300px, 70%, 800px)' : 'clamp(300px, 70%, 500px)',
            px: cvl ? { xs: '25px', sm: '50px' } : { xs: '25px', sm: '80px' },
            py: '50px',
            mb: 2,
            borderRadius: '10px',
            boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
          }}>
          <Typography
            component="h1"
            variant="h5"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 28,
              fontWeight: 600,
              color: 'primary.main',
              mb: '50px',
              textAlign: 'center',
            }}>
            {LoginText}
          </Typography>
          {children}
        </Box>
      </Box>
      {/* <Footer /> */}
    </Stack>
  );
};
// Login Layout End

// Header & Sidenav
export const drawerWidth = '169px';

const MenuButton = ({
  to = null,
  text,
  children,
  downArrow,
  onClick,
}: {
  to?: string | null;
  text: string;
  children: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
}) => {
  const { path } = useRouteMatch();
  const match = to
    ? path.includes(to)
    : text === 'Applications'
    ? [
        '/onboarding',
        '/applications',
        '/application',
        '/application-details/:id',
        '/non-individual-application-details/:id',
        '/non-individual-application',
        '/application-preview/:id',
        '/non-individual-application-preview/:id',
        '/view-consent-email-list',
        '/view-top-up-list',
        '/create-bulk-physical-applications',
      ].includes(path)
    : text === 'KYC Applications'
    ? ['/kyc-onboarding', '/kyc-applications'].includes(path)
    : text === 'Funds Setup'
    ? ['/funds-setup', '/create-bulk-funds'].includes(path)
    : text === 'User Management' && ['/user-management', '/create-bulk-user'].includes(path);
  const disabled = to === null;
  return (
    <ListItemButton
      onClick={onClick}
      component={disabled ? Typography : RouterLink}
      to={to || ''}
      sx={{
        p: { xs: '10px 20px', md: 3 },
        background: match
          ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
          : 'transparent',
        color: match ? 'primary.main' : 'secondary.main',
        stroke: match ? '#2057A6' : '#131836',
        strokeWidth: 0,
        '.MuiSvgIcon-root ': {
          opacity: match ? 1 : 0.5,
        },
        ':hover': {
          background: match
            ? 'linear-gradient(88.93deg, rgba(51, 127, 201, 0.10) 24.43%, rgba(51, 127, 201, 0) 93.37%)'
            : 'transparent',
        },
        textAlign: 'center',
        // pointerEvents: text === 'Funds Setup' ? 'none' : 'all',
      }}>
      {children}
      <ListItemText primary={text} secondary={downArrow && <ExpandMoreIcon />} />
    </ListItemButton>
  );
};

const KfinDrawer = ({ onToggleClick }: { onToggleClick: () => void }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState<{ normal: boolean; kyc: boolean }>({
    normal: false,
    kyc: false,
  });
  const [openUser, setOpenUser] = useState(false);
  const [openFund, setOpenFund] = useState(false);
  const { role = '', adminSupport } = useSelector((store: RootStateType) => store.auth);
  const topUpRole = [
    USER_ROLES.POAAPPROVER,
    USER_ROLES.RTAAPPROVER,
    USER_ROLES.AMCAPPROVER,
  ].includes(role);

  return (
    <Box>
      <List
        sx={{
          pt: { xs: 2, md: 6 },
          '& .MuiListItemButton-root': {
            mb: 1,
            flexDirection: { xs: 'row', md: 'column' },
            '& .MuiListItemText-root': { mx: { xs: 1, md: 0 } },
            '& .MuiListItemText-root span': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: 16,
              fontWeight: 500,
            },
          },
        }}>
        <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
          <IconButton onClick={onToggleClick} aria-label="close drawer" sx={{ color: '#00D9DA' }}>
            <CancelIcon />
          </IconButton>
        </Box>
        {!topUpRole && (
          <MenuButton to="/dashboard" text="Dashboard">
            <DashboardIcon />
          </MenuButton>
        )}
        <MenuButton
          text="Applications"
          downArrow={!open.normal}
          onClick={() => setOpen((open) => ({ ...open, normal: !open.normal }))}>
          <ApplicationsIcon />
        </MenuButton>
        {open.normal && (
          <Box
            sx={{
              textAlign: 'center',
              '.MuiTypography-root': {
                my: 1,
                py: 1,
                fontWeight: 500,
                fontSize: 14,
                display: 'block',
                textDecoration: 'none',
                color: 'text.primary',
                background:
                  'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
              },
            }}>
            {!topUpRole && (
              <Typography
                component={RouterLink}
                to="/onboarding"
                onClick={() => {
                  dispatch(getParams(initialState));
                }}>
                Add New
              </Typography>
            )}
            <Typography
              component={RouterLink}
              to={{
                pathname: topUpRole ? '/applications-list' : '/applications',
                state: { menuClicked: 'normal' },
              }}
              onClick={() => {
                dispatch(getParams(initialState));
              }}>
              View Existing
            </Typography>
            {ENABLE_Email_Consent && !topUpRole && (
              <Typography component={RouterLink} to="/view-consent-email-list">
                View Email Consent
              </Typography>
            )}
            <Typography
              component={RouterLink}
              to={{
                pathname: topUpRole ? '/applications-list' : '/view-top-up-list',
                state: { isTopUp: topUpRole, menuClicked: 'topup' },
              }}
              onClick={() => {
                dispatch(getParams(initialState));
              }}>
              View Top Up Application
            </Typography>
            {USER_ROLES.AMC_ADMIN === role && ENABLE_PHYSICAL_APPLICATION && (
              <Typography component={RouterLink} to="/create-bulk-physical-applications">
                Create Bulk Physical Applications
              </Typography>
            )}
            <IconButton onClick={() => setOpen((open) => ({ ...open, normal: !open.normal }))}>
              <ExpandLessIcon sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box>
        )}
        {MakerOrAdmin(role) && ENABLE_DIGILOCKER_FLOW && (
          <>
            <MenuButton
              text="KYC Applications"
              downArrow={!open.kyc}
              onClick={() => setOpen((open) => ({ ...open, kyc: !open.kyc }))}>
              <ApplicationsIcon />
            </MenuButton>
            {open.kyc && (
              <Box
                sx={{
                  textAlign: 'center',
                  '.MuiTypography-root': {
                    my: 1,
                    py: 1,
                    fontWeight: 500,
                    fontSize: 14,
                    display: 'block',
                    textDecoration: 'none',
                    color: 'text.primary',
                    background:
                      'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                  },
                }}>
                <Typography
                  component={RouterLink}
                  to="/kyc-onboarding"
                  onClick={() => {
                    dispatch(getParams(initialState));
                  }}>
                  Add New
                </Typography>
                <Typography
                  component={RouterLink}
                  to="/kyc-applications"
                  onClick={() => {
                    dispatch(getParams(initialState));
                  }}>
                  View Existing
                </Typography>
                <IconButton onClick={() => setOpen((open) => ({ ...open, kyc: !open.kyc }))}>
                  <ExpandLessIcon sx={{ color: 'primary.main' }} />
                </IconButton>
              </Box>
            )}
          </>
        )}
        {USER_ROLES.AMC_ADMIN === role && (
          <>
            {ENABLE_BLUK_UPLOAD_USERS_AND_FUND ? (
              <>
                <MenuButton
                  text="User Management"
                  downArrow={!openUser}
                  onClick={() => setOpenUser(!openUser)}>
                  <PersonOutlineOutlinedIcon />
                </MenuButton>
                {openUser && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      '.MuiTypography-root': {
                        my: 1,
                        py: 1,
                        fontWeight: 500,
                        fontSize: 14,
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.primary',
                        background:
                          'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                      },
                    }}>
                    <Typography component={RouterLink} to="/user-management">
                      Users
                    </Typography>
                    <Typography component={RouterLink} to="/create-bulk-user">
                      Create Bulk Users
                    </Typography>
                    <IconButton onClick={() => setOpenUser(!openUser)}>
                      <ExpandLessIcon sx={{ color: 'primary.main' }} />
                    </IconButton>
                  </Box>
                )}
                <MenuButton
                  text="Funds Setup"
                  downArrow={!openFund}
                  onClick={() => setOpenFund(!openFund)}>
                  <>
                    <FundsSetup />
                  </>
                </MenuButton>
                {openFund && (
                  <Box
                    sx={{
                      textAlign: 'center',
                      '.MuiTypography-root': {
                        my: 1,
                        py: 1,
                        fontWeight: 500,
                        fontSize: 14,
                        display: 'block',
                        textDecoration: 'none',
                        color: 'text.primary',
                        background:
                          'linear-gradient(90deg, rgba(15, 212, 216, 0.072) 0%, rgba(97, 209, 214, 0) 100%)',
                      },
                    }}>
                    <Typography component={RouterLink} to="/funds-setup">
                      Funds
                    </Typography>
                    <Typography component={RouterLink} to="/create-bulk-funds">
                      Create Bulk Funds
                    </Typography>
                    <IconButton onClick={() => setOpenUser(!openUser)}>
                      <ExpandLessIcon sx={{ color: 'primary.main' }} />
                    </IconButton>
                  </Box>
                )}
              </>
            ) : (
              <>
                <MenuButton text="User Management" to="/user-management">
                  <PersonOutlineOutlinedIcon />
                </MenuButton>
                <MenuButton text="Funds Setup" to="/funds-setup">
                  <FundsSetup />
                </MenuButton>
              </>
            )}
            <MenuButton text="Reports" to="/reports">
              <Reports />
            </MenuButton>
            {adminSupport && (
              <MenuButton text="Admin Support" to="/admin-support">
                <RiskProfile />
              </MenuButton>
            )}
            {/* <MenuButton text="Risk Profile" to="/risk-profile">
              <RiskProfile />
            </MenuButton> */}
          </>
        )}
        {USER_ROLES.SUPER_ADMIN === role && (
          <MenuButton text="AMC Admins" to="/amc-admins">
            <AMCAdmins />
          </MenuButton>
        )}
        {/* <MenuButton to="" text="Settings">
          <SettingsIcon />
        </MenuButton> */}
        <Box
          sx={{
            '& .MuiSvgIcon-root': { opacity: 0.8, width: 24, height: 24 },
            '& .MuiTypography-body1': { background: '#fff' },
          }}>
          <MenuButton text="Logout" onClick={() => dispatch(logout())}>
            <ExitToApp fontSize="large" sx={{ color: 'primary.main' }} />
          </MenuButton>
        </Box>
      </List>
    </Box>
  );
};

export const HeaderSidenav = (): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: 'white',
          boxShadow: 'none',
        }}>
        <Toolbar sx={{ px: { xs: 2, lg: 6 } }}>
          <Box sx={{ ml: 'auto' }}>
            <LogoSideBar />
          </Box>
          {/* <Box sx={{ display: 'flex' }}>
            <IconButton onClick={() => history.push('/profile')}>
              <AccountCircleIcon fontSize="large" sx={{ color: 'primary.main' }} />
            </IconButton>
          </Box> */}
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' }, color: 'secondary.main' }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="side nav">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="right"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}>
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              mt: '100px',
              border: 0,
              maxHeight: 'calc(100vh - 100px)',
              overflow: 'scroll',
              // pb: 'calc(65px + 10%)',
              // justifyContent: 'center',
            },
          }}
          open>
          <KfinDrawer onToggleClick={() => setMobileOpen(!mobileOpen)} />
        </Drawer>
      </Box>
    </>
  );
};
// Header & Sidenav END

export const CommonLayout = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const topUpRole = [
    USER_ROLES.POAAPPROVER,
    USER_ROLES.RTAAPPROVER,
    USER_ROLES.AMCAPPROVER,
  ].includes(role);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          // minHeight: 'calc(100vh - 43px)',
          // overflow: 'auto',
          flexDirection: 'column',
        }}>
        <HeaderSidenav />
        <Box
          component="main"
          sx={{
            mt: '80px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 2, md: topUpRole ? 0 : '50px' },
            pt: { md: topUpRole ? 0 : '20px' },
            borderRadius: '50px 0 0 0',
            bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5)' },
            minHeight: 'calc(100vh - 108px)',
            //overflow: 'auto',
          }}>
          <Container maxWidth={topUpRole ? 'xl' : 'lg'} disableGutters={true}>
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};

export const UserManagementCommonLayout = ({
  children,
  showButton,
}: {
  children: JSX.Element;
  showButton: boolean;
}): JSX.Element => {
  const dispatch = useDispatch();
  const [isSendLoading, setIsSendLoading] = useState(false);

  const downloadUsersData = async () => {
    try {
      setIsSendLoading(true);
      const res = await dispatch(exportUsersData());
      reportDownload(res as unknown as Blob, 'aif-onboarding-users.xlsx');
    } catch (e) {
      setIsSendLoading(false);
      console.error((e as Error).message);
    } finally {
      setIsSendLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          // minHeight: 'calc(100vh - 43px)',
          // overflow: 'auto',
          flexDirection: 'column',
        }}>
        <HeaderSidenav />
        <Box
          component="main"
          sx={{
            mt: '85px',
            ml: { xs: 0, md: drawerWidth },
            p: { xs: 0, md: '50px' },
            pt: { md: '20px' },
            borderRadius: { xs: '', sm: '50px 0 0 0' },
            bgcolor: 'rgba(238, 244, 251, 0.5)',
            minHeight: 'calc(100vh - 108px)',
            //overflow: 'auto',
          }}>
          <Container maxWidth="lg" disableGutters={true}>
            {showButton && ENABLE_DOWNLOAD_USERS_DATA && (
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
                <Tooltip title="Click here to download users data">
                  <LoadingButton
                    loadingPosition="start"
                    type="submit"
                    loading={isSendLoading}
                    variant="contained"
                    sx={{
                      fontSize: 12,
                      minWidth: isSendLoading ? 220 : '',
                      letterSpacing: 1,
                      fontWeight: 400,
                      px: isSendLoading ? 0 : 2,
                      py: 1,
                      mt: 1,
                    }}
                    onClick={downloadUsersData}>
                    Download Users Data
                  </LoadingButton>
                </Tooltip>
              </Box>
            )}
            {children}
          </Container>
        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};
export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  onCancel,
  onSave,
}: {
  message: string;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
}): JSX.Element => {
  return (
    <Dialog open={open} onClose={setOpen}>
      <Box
        sx={{
          p: { xs: 2, sm: '45px 40px' },
          borderRadius: '10px',
          // width: { xs: '70%', sm: '70%' },
          maxWidth: 400,
          height: { xs: '90%', md: 'unset' },
          overflowY: 'auto',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiButton-root': {
              minWidth: 100,
              fontSize: 16,
            },
          }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              color: '#337FC9',
              textAlign: 'center',
              mb: 5,
            }}>
            {message}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              '.MuiButton-root': {
                minWidth: '100px',
              },
            }}>
            <Button variant="contained" onClick={onSave} sx={{ color: 'common.white' }}>
              Yes
            </Button>
            <Button variant="outlined" onClick={onCancel} sx={{ color: 'primary.main' }}>
              No
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({ title, ...props }: Props): JSX.Element {
  // eslint-disable-next-line
  const { onClose, ...rest } = props;
  const isCvl = title && title?.toLowerCase() === 'cvl';
  const customisedProps = isCvl ? { ...rest } : { ...props };
  const parsedJson =
    isCvl && isJson(customisedProps?.content)
      ? JSON.parse(customisedProps?.content)
      : customisedProps?.content;
  return (
    <Dialog
      {...rest}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: isCvl ? 'left' : 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      {!isCvl && title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {!isCvl ? (
          <DialogContentText>{parsedJson}</DialogContentText>
        ) : (
          <Box>
            <JSONPretty
              id="json-pretty"
              data={parsedJson}
              mainStyle="line-height:1.3;over-flow:auto"
              keyStyle="color:black"
              stringStyle="color:#888"
              booleanStyle="color:#888"
              valueStyle="color:#888"
              errorStyle="line-height:1.3;color:red;overflow:auto;"></JSONPretty>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, index) => (
          <Button variant="contained" color="primary" key={index} onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export function CommonLayoutForPOA(): JSX.Element {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: { xs: 0, sm: '48px' },
            paddingLeft: { xs: 0, sm: '48px' },
          }}>
          <Logo2 />
          {role !== USER_ROLES.INVESTOR && (
            <Box sx={{ display: 'flex' }}>
              <IconButton onClick={() => dispatch(logout())}>
                <ExitToApp fontSize="large" sx={{ color: 'primary.main' }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </AppBar>
      <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
    </>
  );
}

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
}: {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                padding: '12px 15px 12px 0',
                border: 'none',
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
          svg: {
            color: '#337FC9',
          },
        }}>
        <Select
          labelId="user-items"
          onChange={(e) => {
            setFieldValue(name, `${e.target.value}`);
          }}
          value={value}
          renderValue={(value) => {
            return (
              <Typography>{value.split(':')[1] ? value.split(':')[1].trim() : value}</Typography>
            );
          }}
          MenuProps={{
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            sx: {
              '.MuiPaper-root ': {
                width: ElementWidth,
                ml: '-10px',
                maxHeight: '20%',
                overflowX: 'auto',
              },
            },
            disableAutoFocusItem: true,
            MenuListProps: {
              disableListWrap: true,
            },
          }}
          onClose={() => {
            setQuery('');
          }}
          readOnly={readOnly}
          disabled={disabled}>
          <SearchFieldWrapper searchFieldPlaceholder={'Search...'} setQuery={setQuery} />
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
          {/* {getCountryCodes().map((codes, ind) => (
            <MenuItem value={codes.label} key={ind}>
              {codes.label}
            </MenuItem>
          ))} */}
        </Select>
      </Box>
    </InputAdornment>
  );
}
export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup.string().required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});
export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <Dialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, this PAN has failed the AML check
        </Typography>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.7)',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'rgba(0,0,0,0.7)',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      <KeyValue title={'Aml Check'} description={amlCheck?.toString().toUpperCase() || ''} />
      <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid>
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box sx={styles.ApplicationDetailsCommonLayout} my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography
                  component="h2"
                  sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'Primary Contributor Details',
                    'Joint Contributor 1 Details',
                    'Joint Contributor 2 Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={index}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'common.black',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </Dialog>
  );
};

export const FileUploadDialog = ({
  show,
  handleClose,
  message,
  code,
}: {
  show: boolean;
  handleClose: () => void;
  message?: string;
  code: string;
}): JSX.Element => {
  return (
    <Dialog
      open={show}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          color: '#4f4f4f',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      <DialogContent>
        <DialogContentText>
          {' '}
          <Typography sx={{ textAlign: 'center' }}>{message}</Typography>
          {code === 'FILE_ENCRYPTION_ERROR' && (
            <>
              <Typography fontWeight={450} mt={2}>
                {' '}
                Steps for flattening PDF
              </Typography>
              <Typography mt={1}>
                &bull; Right click on the file, and navigate to “Open With” and choose Chrome
                browser.
              </Typography>
              <Typography>&bull; Then Open the print menu by pressing Ctrl+P</Typography>
              <Typography>
                &bull; Under the “Printer” drop-down menu, select “Microsoft Print to PDF” or “Save
                as PDF”.
              </Typography>
              <Typography> &bull; Click “Print”.</Typography>
              <Typography>&bull; When prompted, choose where you want to save the file.</Typography>
              <Typography> &bull; Upload the newly saved file.</Typography>
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const SendbackDialog = ({
  handleSendBackClose,
  openSendBackDialog,
  sendBackLoading,
  onSendBackSubmit,
  role,
  extraTexttodisplay = true,
}: {
  handleSendBackClose: () => void;
  openSendBackDialog: boolean;
  sendBackLoading: boolean;
  onSendBackSubmit: (values: SendBackType) => void;
  // eslint-disable-next-line
  role: any;
  extraTexttodisplay?: boolean;
}): JSX.Element => {
  const initialCommentValues: SendBackType = { comment: '', sendBackTo: '' };
  const isApproverTextToshow = !MakerOrAdmin(role) && extraTexttodisplay;
  const Commentvalidation = yup.object().shape({
    sendBackTo: yup
      .string()
      .nullable()
      .test('sendBackTo', (value, context) => {
        const { createError, path } = context;
        if (RTAApproverLoggedIn(role)) {
          if (!value) {
            return createError({ message: 'value for to whom send back is required', path });
          }
          if (!Object.keys(RTAApproverSendBackRoles).includes(value)) {
            return createError({ message: 'Invalid value for to whom send back', path });
          }
        }
        return true;
      }),
    comment: yup.string().nullable().required('Please provide Comment'),
  });
  return (
    <Dialog
      onClose={handleSendBackClose}
      open={openSendBackDialog}
      sx={styles.ApplicationApproveRejectSendbackDialog}>
      <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Box sx={styles.ApplicationApproveRejectSendbackDialogBox}>
        {isApproverTextToshow && (
          <Typography sx={{ color: 'primary.main' }}>
            Are you sure you want to{' '}
            <Typography component="span" sx={{ color: '#BD2932' }}>
              Send Back
            </Typography>{' '}
            the application?
          </Typography>
        )}
        <Typography sx={{ color: '#BD2932', mt: isApproverTextToshow ? 5 : 2 }}>
          {' '}
          Give Comments for application Send Back *
        </Typography>
        <Formik
          initialValues={initialCommentValues}
          onSubmit={onSendBackSubmit}
          validationSchema={Commentvalidation}>
          {({ handleSubmit }) => (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              {RTAApproverLoggedIn(role) && (
                <MFSelectField
                  label="To whom send back"
                  name="sendBackTo"
                  items={Object.keys(RTAApproverSendBackRoles).map((item) => ({
                    key: RTAApproverSendBackRoles[item],
                    value: item,
                  }))}
                />
              )}
              <MFTextField
                name="comment"
                multiline
                rows={4}
                placeholder="Type your answer here..."
              />

              <Grid
                container
                sx={{
                  my: 3,
                  justifyContent: 'center',
                  gap: 1.5,
                  '.MuiButton-root': {
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  },
                }}>
                <Button
                  onClick={handleSendBackClose}
                  variant="outlined"
                  sx={{ color: 'primary.main' }}
                  disabled={sendBackLoading}>
                  Cancel
                </Button>
                <LoadingButton loading={sendBackLoading} variant="contained" type="submit">
                  Continue
                </LoadingButton>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export function MobileNumberField({
  name,
  countryCodeFieldName,
  label,
  placeholder,
  defaultValue,
  margin,
  onChange,
  trimOnBlur,
  displayCharecterCounter = '',
  countryCodeValue,
  readOnly = false,
  disabled = false,
  regexForFilterValue,
  type = 'string',
  ...props
}: InputBaseProps & {
  name: string;
  countryCodeFieldName: string;
  countryCodeValue: string;
  readOnly?: boolean;
  disabled?: boolean;
  label?: string;
  margin?: 'dense' | 'none' | undefined;
  placeholder: string;
  defaultValue?: string;
  trimOnBlur?: boolean;
  displayCharecterCounter?: string;
  regexForFilterValue?: RegExp;
}): JSX.Element {
  const [mobileElementWidth, setMobileElementWidth] = useState<number | null>(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName(name);
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as number | null);
  }, []);
  return (
    <MFTextField
      defaultValue={defaultValue}
      label={label}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      readOnly={readOnly}
      disabled={disabled}
      margin={margin}
      trimOnBlur={trimOnBlur}
      type={type}
      displayCharecterCounter={displayCharecterCounter}
      regexForFilterValue={regexForFilterValue}
      {...props}
      onKeyDown={(e) => {
        preventSpecialCharacters(e);
      }}
      startAdornment={
        <CountryCodesDropDown
          ElementWidth={mobileElementWidth && mobileElementWidth}
          name={countryCodeFieldName}
          value={countryCodeValue}
          readOnly={readOnly}
          disabled={disabled}
        />
      }
    />
  );
}

export const ApplicationHeaderStyles = {
  applicationHeader: { fontSize: 18, fontWeight: 600, color: 'text.secondary' },
};

export function ApplicationHeader({ application }: { application: ApplicationProps }): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <Box sx={styles.ApplicationDetailsCommonLayout} mb={3}>
      <Box sx={{ p: 2 }}>
        <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={2}>
            <Typography sx={ApplicationHeaderStyles.applicationHeader}>
              {application.isTopup ? 'Top Up ID' : 'Application ID'}:{' '}
              {application.isTopup
                ? application.topupApplicationNumber
                : application.applicationNumber}
            </Typography>
            {!!Number(application.folio_no || application.xalt_folio_no) && (
              <Typography sx={ApplicationHeaderStyles.applicationHeader}>
                Folio Number: {application.folio_no || application.xalt_folio_no}
              </Typography>
            )}
            <Typography
              className={ApplicationStatusOrClassBasedOnRole(application, role)}
              sx={{
                fontSize: 18,
                fontWeight: 600,
                color: 'text.secondary !important',
                '&.Draft .MuiTypography-root': {
                  color: 'rgba(51, 127, 201, 0.7) !important',
                },
                '&.Completed .MuiTypography-root': {
                  fontWeight: 600,
                  color: 'rgba(35, 133, 63, 0.7) !important',
                },
                '&.Rejected .MuiTypography-root': {
                  color: '#BD2932 !important',
                  fontWeight: 500,
                },
              }}>
              Status:{' '}
              <Typography
                component="span"
                sx={{
                  color: '#986f09',
                  fontSize: '16px',
                  letterSpacing: '0.4px',
                  ml: 0.5,
                }}>
                {ApplicationStatusOrClassBasedOnRole(application, role)}
              </Typography>
            </Typography>
            {[
              USER_ROLES.RM,
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.SUBDISTRIBUTOR,
              USER_ROLES.AMCAPPROVER,
              USER_ROLES.RTAAPPROVER,
              USER_ROLES.AMC_ADMIN,
            ].includes(role) &&
              application.signedLeegalityFile?.url && (
                <Tooltip title={'Download'}>
                  <IconButton
                    sx={{
                      p: 0,
                      pr: 0.5,
                      ':hover': {
                        bgcolor: '#F4FCFC',
                      },
                      cursor: 'pointer',
                      pointerEvents: 'all',
                    }}
                    onClick={async () => {
                      try {
                        // application?.signedLeegalityFile?.url && window.open(application?.signedLeegalityFile?.url)
                        application?.signedLeegalityFile?.url &&
                          (await handleDownload(
                            application?.signedLeegalityFile?.url as string,
                            `${
                              application.topupInitiated
                                ? application.topupApplicationNumber
                                : application.applicationNumber
                            }.pdf`
                          ));
                      } catch (e) {
                        console.error((e as Error).message);
                      }
                    }}>
                    <CardMedia
                      component="img"
                      src={'/images/download-icon.png'}
                      alt="Download"
                      sx={{ width: '25px' }}
                    />
                  </IconButton>
                </Tooltip>
              )}
          </Grid>
          {application.status === 'rejected' && (
            <Grid
              item
              container
              pb={5}
              rowSpacing={1}
              columnSpacing={13}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start">
              <RejectedDetails
                title={'Rejected by'}
                description={REJECTED_ROLES[application.rejectedByRole]}
              />
              <RejectedDetails
                title={'Rejected on'}
                description={formatShortDateAndTime(application.rejectedAt)}
              />
              <RejectedDetails
                title={'Reason for rejection'}
                description={application.rejectedReason}
              />
            </Grid>
          )}
          {application?.isPhysicalApplication && (
            <Notes displayContent="This Application is being created physically" />
          )}
        </Grid>
      </Box>
    </Box>
  );
}
